/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type SkillCategoryRow_skillCategory = {
    readonly id: string;
    readonly name: string | null;
    readonly " $refType": "SkillCategoryRow_skillCategory";
};
export type SkillCategoryRow_skillCategory$data = SkillCategoryRow_skillCategory;
export type SkillCategoryRow_skillCategory$key = {
    readonly " $data"?: SkillCategoryRow_skillCategory$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"SkillCategoryRow_skillCategory">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SkillCategoryRow_skillCategory",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "type": "SkillCategory"
};
(node as any).hash = '87ed52423512a020c8ee085652356932';
export default node;
